import { render, staticRenderFns } from "./zselect.vue?vue&type=template&id=1a072f09&scoped=true&"
import script from "./zselect.vue?vue&type=script&lang=js&"
export * from "./zselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a072f09",
  null
  
)

export default component.exports